<script setup>
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';
import PostSaleNoteItem from './PostSaleNoteItem.vue';

defineProps({
  notes: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  canManage: { type: Boolean, default: false },
});

const emit = defineEmits(['add', 'delete', 'edit']);
const { t } = useI18n();
</script>

<template>
  <LaisCard
    :title="t('POST_SALE.NOTES.TITLE')"
    density="flush"
    prefix-icon="i-lucide-notebook-pen"
  >
    <div v-if="loading" class="grid gap-3 bg-lais-bg-soft p-5">
      <div
        v-for="index in 2"
        :key="index"
        class="h-28 animate-pulse rounded-lais-sm bg-lais-bg-soft"
      />
    </div>
    <div
      v-else-if="!notes.length"
      class="bg-lais-bg-soft p-5 text-sm text-lais-text-muted"
    >
      {{ t('POST_SALE.NOTES.EMPTY') }}
    </div>
    <div
      v-else
      class="max-h-[500px] overflow-y-auto border-y border-lais-border-soft bg-lais-bg-soft"
    >
      <PostSaleNoteItem
        v-for="note in notes"
        :key="note.id"
        :note="note"
        :can-delete="canManage && note.permissions?.can_delete"
        :can-edit="canManage && note.permissions?.can_edit"
        @delete="emit('delete', $event)"
        @edit="emit('edit', $event)"
      />
    </div>
    <template #footer>
      <div class="flex justify-end px-2 py-1">
        <LaisPrimaryButton
          v-if="canManage"
          variant="ghost"
          icon="i-lucide-plus"
          @click="emit('add')"
        >
          {{ t('POST_SALE.NOTES.ACTIONS.ADD') }}
        </LaisPrimaryButton>
      </div>
    </template>
  </LaisCard>
</template>
